import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { BetaContext } from '../context/BetaContext';

const BetaProtectedRoute = ({ element, requireAdmin = false }) => {
  const { betaUser, loading } = useContext(BetaContext);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!betaUser) {
    return <Navigate to="/beta/login" replace />;
  }

  if (requireAdmin && betaUser.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default BetaProtectedRoute;
